import React, { useState } from 'react';
import { StyleProp, TextStyle, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../MyAppText';
import MyDropDownPicker, { ValueType } from '../../MyDropDownPicker';
import { DropDownPickerProps } from 'react-native-dropdown-picker';
import { Hoverable } from 'react-native-web-hover';
import TooltipWrapper from '../../TooltipWrapper';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type DistributiveOmit<T, K extends keyof any> = T extends any
    ? Omit<T, K>
    : never;

type Props = DistributiveOmit<DropDownPickerProps<ValueType>, 'open' | 'setOpen'>
    & {
        label?: string;
        onChange?: () => void;
        labelFontSize?: number;
        labelStyle?: StyleProp<TextStyle>;
        dropdownLabelStyle?: StyleProp<TextStyle>;
        viewStyle?: StyleProp<TextStyle>;
        required?: boolean;
        semiBoldLabel?: boolean;
        showTooltip?: boolean;
        tooltipText?: string;
        onTooltipHovered?: (hovered: boolean) => void;
        isLoading?: boolean;
        hideLabel?: boolean;
    };

function FilterDropdown({ label, labelFontSize, labelStyle, dropdownLabelStyle, viewStyle, required, showTooltip, tooltipText, onTooltipHovered, semiBoldLabel = false, hideLabel = false, ...props }: Props) {
    const { styles, theme } = useStyles(stylesheet);

    const [isOpen, setIsOpen] = useState(false);

    return (
        <View style={[styles.inputContainer(props.zIndex), viewStyle]}>
            {label && !hideLabel ?
                <View style={{ flexDirection: 'row', gap: 5, zIndex: (props.zIndex || 0) + 1 }}>
                    <MyAppText
                        style={labelStyle ? labelStyle : styles.filterText(labelFontSize ?? 16, semiBoldLabel)}>
                        {label}
                    </MyAppText>
                    {required ?
                        <MyAppText style={{ color: theme.colors.errors['300'] }}>(*)</MyAppText>
                        : null}
                    {showTooltip && tooltipText && <Hoverable>
                        {({ hovered }) => (
                            <TooltipWrapper
                                hovered={hovered}
                                onTooltipHovered={onTooltipHovered}
                                tooltipText={tooltipText}
                            />
                        )}
                    </Hoverable>}
                </View>
                : null}
            <MyDropDownPicker
                {...props}
                labelStyle={dropdownLabelStyle}
                borderColor={theme.colors.field.border}
                searchable={true}
                height={40}
                open={isOpen}
                setOpen={setIsOpen}
                dropDownDirection={props.dropDownDirection ?? 'BOTTOM'}
            />
        </View>
    );
}

const stylesheet = createStyleSheet(theme => ({
    inputContainer: (zIndex: number | undefined) => ({
        zIndex,
        minWidth: 200,
    }),
    filterText: (fontSize: number, semiBoldLabel: boolean) => ({
        color: theme.colors.labelColor,
        fontSize,
        height: 25,
        fontWeight: semiBoldLabel ? '600' : '400'
    }),
}));

export default FilterDropdown;
